/**
 * VOLUME PRICING TIERS — live progress bar (Islands Fabric / Warehouse theme)
 * Watches the quantity-selector input and updates the tier progress bar,
 * active-tier highlight, and messaging in real time.
 */
(function () {
  'use strict';

  function initVolumePricing(root) {
    var wrappers = (root || document).querySelectorAll('.vpt-wrapper');
    wrappers.forEach(function (wrapper) {
      var tiers = Array.prototype.slice
        .call(wrapper.querySelectorAll('.vpt-tier'))
        .map(function (el) {
          return { el: el, qty: parseInt(el.dataset.vptQty, 10), pct: parseInt(el.dataset.vptPct, 10) };
        })
        .sort(function (a, b) { return a.qty - b.qty; });

      var maxTierQty = tiers[tiers.length - 1].qty;
      var fill = wrapper.querySelector('#vpt-progress-fill');
      var message = wrapper.querySelector('#vpt-message');
      var unit = wrapper.dataset.vptUnit || 'yard';

      var qtyInput =
        document.querySelector('.quantity-selector__value') ||
        document.querySelector('.product-form input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]');

      function currentQty() {
        if (!qtyInput) return 1;
        var v = parseInt(qtyInput.value, 10);
        return isNaN(v) || v < 1 ? 1 : v;
      }

      function activeTierFor(qty) {
        var active = null;
        for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].qty) active = tiers[i]; }
        return active;
      }

      function nextTierFor(qty) {
        for (var i = 0; i < tiers.length; i++) { if (qty < tiers[i].qty) return tiers[i]; }
        return null;
      }

      function render() {
        var qty = currentQty();
        var active = activeTierFor(qty);
        var next = nextTierFor(qty);
        var pct = Math.min((qty / maxTierQty) * 100, 100);
        if (fill) fill.style.width = pct + '%';

        tiers.forEach(function (t) {
          t.el.classList.remove('vpt-active', 'vpt-unlocked');
          if (active && t.qty === active.qty) { t.el.classList.add('vpt-active', 'vpt-unlocked'); }
          else if (active && t.qty < active.qty) { t.el.classList.add('vpt-unlocked'); }
        });

        if (message) {
          message.classList.remove('vpt-maxed');
          if (next) {
            var remaining = next.qty - qty;
            message.innerHTML = 'Add <strong>' + remaining + ' more ' + unit + (remaining === 1 ? '' : 's') + '</strong> to unlock <strong>' + next.pct + '% off</strong>';
          } else if (active) {
            message.classList.add('vpt-maxed');
            message.innerHTML = '✓ You’ve unlocked the max discount: <strong>' + active.pct + '% off</strong>';
          }
        }
      }

      if (qtyInput && !qtyInput.dataset.vptBound) {
        qtyInput.dataset.vptBound = '1';
        qtyInput.addEventListener('input', render);
        qtyInput.addEventListener('change', render);
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]')) {
            setTimeout(render, 50);
          }
        });
      }

      render();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initVolumePricing(); });
  document.addEventListener('shopify:section:load', function (e) { initVolumePricing(e.target); });
})();
